import { HomeVisibleLinks } from "./visible-links-home";

export class VisibleLinks {
	Home:HomeVisibleLinks = new HomeVisibleLinks();

	public constructor(data?:any){
		if (!data) return;
		this.Home = new HomeVisibleLinks(data.Home);
	}

	public getJSON(){
		return {
			Home: this.Home.getJSON()
		};
	}
}